<template>
    <div class="footerFail">
        <div class="copyright">
          <p>Copyright ＠ 2023 <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2023024960号-1</a> | 联系方式：0632-3127779</p>
        </div>
    </div>
</template>

<script>
import api from "@/api/index";
import http from "@/utils/request";
export default {
    data() {
        return {
            infoMation: {},
            zddwArr: [],
            imgGfwx: require('./../assets/qxr/weixin.png'),
            imgGfwb: require('./../assets/qxr/weibo.png'),
        }
    },
    created() {
        // this.getInfoMation();
    },
    methods: {
        // leave(val) {
        //     if (this.$router.currentRoute.path == val) {
        //         this.$router.push({ path: val });
        //         this.reload();
        //     } else {
        //         this.$router.push({ path: val });
        //     }
        // },
        // /*
        //    * 获取基础信息
        //    * */
        // getInfoMation() {
        //     const res = http.get(api.infoMation);
        //     res.then((data) => {
        //         this.infoMation = data.data;
        //         let directedUnits = this.infoMation.directedUnit.split(",");
        //         let addresss = this.infoMation.address.split(",");
        //         directedUnits.map((e, index) => {
        //             this.zddwArr.push({
        //                 name: directedUnits[index],
        //                 url: addresss[index]
        //             })
        //         })
        //     });
        // },
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/themeColor.scss';

.footerFail {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    line-height: 50px;
    // background: #275ecb;
    text-align: center;
    background: #B3B3B3;

    .copyright {
        color: #ffffff;
        font-size: 16px;
        a{
          color: #ffffff;
        }
    }
}

// .f-link .collapse-ul li {
//     float: left;
//     margin-right: 40px;
//     font-size: 16px;
//     cursor: pointer;
// }

// .collapse-ul {
//     padding-left: 220px;
// }

// .clearfix:after {
//     content: "";
//     /*内容设置为空！！！*/
//     display: block;
//     /*显示为块级元素！！！*/
//     height: 0;
//     visibility: hidden;
//     clear: both;
//     /*清除浮动！！！*/
// }

// .footerFail {
//     width: 100%;
//     min-width: 1200px;
//     bottom: 0;
//     //background: $footerBack;
//     color: #fff;
//     overflow: auto;
//     //padding-top: 20px;
//     font-size: 16px;
// }

// .container {
//     padding-bottom: 8px;
// }

// .f-link {
//     overflow: hidden;
//     padding-bottom: 15px;
//     border-bottom: 1px solid #fff;
// }

// .carriage-left {
//     width: 900px;
//     float: left;
//     padding-top: 20px;
// }

// .carriage-right {
//     width: 250px;
//     float: right;
//     padding-top: 20px;
// }

// .carriage-right li {
//     width: 96px;
//     text-align: center;
//     float: left;
//     font-size: 14px;
//     margin-right: 40px;
// }

// .carriage-right li:last-child {
//     margin-right: 0;
// }

// .carriage-right li img {
//     width: 96px;
//     height: 96px;
// }

// .carriage-right li p {
//     line-height: 34px;
// }

// .carriage {
//     overflow: hidden;
//     padding-bottom: 15px;
// }

// .f-link p,
// .carriage p {
//     float: left;
//     margin-right: 20px;
// }

// .f-link a {
//     color: #fff !important;
// }

// .carriage {
//     padding: 8px 0;
// }

// .carriage.pt-20 {
//     padding-top: 20px;
// }

// .carriage a {
//     color: #fff;
// }

// .copyright {
//     background: #275ecb;
//     text-align: center;
//     font-size: 16px;
//     height: 50px;
//     line-height: 50px;
// }
</style>



// WEBPACK FOOTER //
// src/components/footerFail.vue